/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Source_EmptyInputs */

const cs_draft_source_empty = /** @type {(inputs: Draft_Source_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prázdné`)
};

const en_draft_source_empty = /** @type {(inputs: Draft_Source_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty`)
};

/**
* | output |
* | --- |
* | "Empty" |
*
* @param {Draft_Source_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_source_empty = /** @type {((inputs?: Draft_Source_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Source_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_source_empty(inputs)
	return cs_draft_source_empty(inputs)
});